import { PaymentMethod, PaymentType, ReceiptStatus } from '@models';

export function utils(): string {
  return 'utils';
}

export function convertImageUrlToBlob(dataURL: string): Blob {
  const byteString = atob(dataURL.split(',')[1]);
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const uint8Array = new Uint8Array(arrayBuffer);
  for (let i = 0; i < byteString.length; i++) {
    uint8Array[i] = byteString.charCodeAt(i);
  }
  return new Blob([uint8Array], { type: 'image/png' });
}

/**
 * Extracts a user-friendly error message from a Firebase callable HttpsError.
 * Returns the backend message if it's meaningful, otherwise falls back to the provided string.
 */
export function parseBackendError(
  e: any,
  fallback = 'Error desconocido',
): string {
  const msg = e?.message;
  if (msg && typeof msg === 'string') {
    // Skip raw Firebase generic codes that aren't user-friendly
    const genericMessages = [
      'INTERNAL',
      'UNAUTHENTICATED',
      'UNKNOWN',
      'internal',
    ];
    if (!genericMessages.includes(msg)) {
      return msg;
    }
  }
  return fallback;
}

export const PAYMENT_METHODS: Record<PaymentMethod, string> = {
  [PaymentMethod.CARD]: 'Tarjeta',
  [PaymentMethod.BANK]: 'Transferencia',
};

export const PAYMENT_METHODS_SELECTOR: {
  label: string;
  value: PaymentMethod;
}[] = [
  { value: PaymentMethod.CARD, label: PAYMENT_METHODS[PaymentMethod.CARD] },
  { value: PaymentMethod.BANK, label: PAYMENT_METHODS[PaymentMethod.BANK] },
];

export const PAYMENT_TYPES: Record<PaymentType, string> = {
  [PaymentType.TEAMS]: 'Equipos',
  [PaymentType.PLAYERS]: 'Jugadores',
  [PaymentType.REFEREE]: 'Arbitrajes',
  [PaymentType.INDIVIDUAL]: 'Inscripción individual',
  [PaymentType.MEMBERSHIP]: 'Cuota de socio',
  [PaymentType.BONO]: 'Bono de sesiones',
};

export const PAYMENT_TYPES_SELECTOR: { label: string; value: PaymentType }[] = [
  { value: PaymentType.TEAMS, label: PAYMENT_TYPES[PaymentType.TEAMS] },
  { value: PaymentType.PLAYERS, label: PAYMENT_TYPES[PaymentType.PLAYERS] },
  { value: PaymentType.REFEREE, label: PAYMENT_TYPES[PaymentType.REFEREE] },
];

export const RECEIPT_STATUSES: Record<ReceiptStatus, string> = {
  [ReceiptStatus.LINK_CREATED]: 'Enlace creado',
  [ReceiptStatus.READY_TO_SIGN]: 'Pendiente de firmar',
  [ReceiptStatus.PAYMENT_PAID]: 'Pago realizado',
  [ReceiptStatus.SIGNED]: 'Recibo firmado',
  [ReceiptStatus.FEDERATION_PAID]: 'Recibo abonado',
};

export const RECEIPT_STATUS_SELECTOR: {
  label: string;
  value: ReceiptStatus;
}[] = [
  {
    value: ReceiptStatus.LINK_CREATED,
    label: RECEIPT_STATUSES[ReceiptStatus.LINK_CREATED],
  },
  {
    value: ReceiptStatus.READY_TO_SIGN,
    label: RECEIPT_STATUSES[ReceiptStatus.READY_TO_SIGN],
  },
  {
    value: ReceiptStatus.PAYMENT_PAID,
    label: RECEIPT_STATUSES[ReceiptStatus.PAYMENT_PAID],
  },
  {
    value: ReceiptStatus.SIGNED,
    label: RECEIPT_STATUSES[ReceiptStatus.SIGNED],
  },
  {
    value: ReceiptStatus.FEDERATION_PAID,
    label: RECEIPT_STATUSES[ReceiptStatus.FEDERATION_PAID],
  },
];
